export enum ActiveWindows {
    Experience,
    Skills,
    Projects,
    Education
}